export var FINISHED_STATUS = [12, 13];
export var COURIER_DELIVERED_STATUS = [12];